// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wjBP","selected":"styles_selected__19UoN"};